<template>
  <div id="chapters">
    <router-link :to="{ name: 'Home'}" v-tooltip="$t('menu.home')" class="close-popup">
      <svg viewBox="0 0 37 37" xmlns="http://www.w3.org/2000/svg"><path d="m21.736 18.51208c-.0714717-.0712912-.1116393-.1680913-.1116393-.26904s.0401676-.1977488.1116393-.26904l14.07976-14.07824c.8902609-.89152014.8892401-2.33593905-.00228-3.22619997-.8915202-.89026091-2.3359391-.88924013-3.2262.00227997l-14.07824 14.07216c-.0712912.0714717-.1680913.1116393-.26904.1116393s-.1977488-.0401676-.26904-.1116393l-14.07824-14.07216c-.89026093-.89068066-2.33399934-.89102093-3.22468-.00076-.89068066.89026093-.89102093 2.33399934-.00076 3.22468l14.07672 14.07824c.0714717.0712912.1116393.1680913.1116393.26904s-.0401676.1977488-.1116393.26904l-14.07672 14.07976c-.57589784.5761694-.80066669 1.4158096-.58963831 2.2026365.21102838.7868268.82579378 1.4013025 1.61272 1.61196s1.62646047-.0145071 2.20235831-.5906765l14.07824-14.07976c.0712912-.0714717.1680913-.1116393.26904-.1116393s.1977488.0401676.26904.1116393l14.07824 14.07976c.8902609.8906806 2.3339993.8910209 3.22468.00076.8906806-.8902609.8910209-2.3339993.00076-3.22468z" /></svg>
    </router-link>
    <div class="chapters-container">
      <div class="container">
        <h1>{{ showChapters ? $t('chapters-list.title.chapters') : $t('chapters-list.title.annexes') }}</h1>
        <ul class="chapters-list">
          <li :class="{ 'is-active': showChapters }" @click="showChaptersList">{{ $t('chapters-list.chapters') }}</li>
          <li :class="{ 'is-active': !showChapters }" @click="showAnnexesList">{{ $t('chapters-list.annexes') }}</li>
        </ul>
        <div class="chapters-thumbnails" v-show="showChapters">
          <div class="chapter-container" v-for="chapter in chapters" :key="chapter.title">
            <chapter-card
              :title="chapter.title"
              :thumbnail="chapter.thumbnail"
              :duration="chapter.duration"
              :timeCode="chapter.timeCode"
            />
          </div>
        </div>
        <div class="chapters-thumbnails" v-show="!showChapters">
          <div class="chapter-container" v-for="annexe in annexes" :key="annexe.title">
            <annexe-card
              :title="annexe.title"
              :thumbnail="annexe.thumbnail"
              :duration="annexe.duration"
              :type="annexe.type"
              :url="annexe.url"
              :picture="annexe.picture"
              :vimeoId="annexe.vimeoId"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../locales'
import ChapterCard from '../components/ChapterCard.vue'
import AnnexeCard from '../components/AnnexeCard.vue'

export default {
  name: 'Chapters',

  components: {
    ChapterCard, AnnexeCard
  },

  data: function () {
    return {
      showChapters: true,

      chapters: [
        {
          title: i18n.t('chapters.1.title'),
          thumbnail: '2c2d4f4baaa9782d320fade2f84a4bb5680e0b32.png',
          duration: 126,
          timeCode: 0
        },
        {
          title: i18n.t('chapters.2.title'),
          thumbnail: 'dd1aca26f15561982a26c120048b3a65c6b507f1.png',
          duration: 537,
          timeCode: 126
        },
        {
          title: i18n.t('chapters.3.title'),
          thumbnail: 'ziU237NNh4CxCmQ6LA2aTvZrLiTmTGSR5yFr31IH.png',
          duration: 572,
          timeCode: 663
        },
        {
          title: i18n.t('chapters.4.title'),
          thumbnail: 'HVBm4msmmok36SkqEOXZYzd00k6uwd1RhUAFLB08.png',
          duration: 702,
          timeCode: 1235
        }
      ],

      annexes: [
        {
          title: 'Interview d’étudiants coréens 1',
          thumbnail: '89d288881dbdd0826f5312670a24f19e8223b27e.jpg',
          vimeoId: 344905110,
          duration: 1598,
          type: 'video'
        },
        {
          title: 'Interview d’étudiants coréens 2',
          thumbnail: '0a8c620eeef67649049946c35988dff27895dfa0.jpg',
          vimeoId: 344905022,
          duration: 1458,
          type: 'video'
        },
        {
          title: 'Frise chronologique',
          thumbnail: i18n.t('annexes.timeline.thumbnail'),
          picture: i18n.t('annexes.timeline.picture'),
          type: 'picture'
        },
        {
          title: i18n.t('annexes.map.title'),
          thumbnail: '201905241616321.png',
          type: 'iframe',
          url: 'https://www.google.com/maps/d/u/0/embed?mid=1Z1g9OsHp09iAvGdEeYYcnnxFaBmTa-mC'
        }
      ]
    }
  },

  methods: {
    showChaptersList () {
      this.showChapters = true
    },

    showAnnexesList () {
      this.showChapters = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#chapters {
  background-color: rgba(26, 103, 249, .35);
  flex-direction: row;
  overflow: hidden;
  margin: 0 auto;
  display: flex;
  z-index: 1;
  flex: 1;

  @media screen and (min-width: 992px) {
    overflow: auto;
  }

  .close-popup {
    position: absolute;
    display: flex;
    color: #fff;
    right: 32px;
    z-index: 9;
    top: 32px;

    svg {
      fill: currentColor;
      width: 32px;
    }
  }

  .chapters-container {
    padding: 0 15px;
    display: flex;
    margin: auto;
    width: 100%;
  }

  .chapters-list {
    text-transform: uppercase;
    margin-bottom: 1rem;
    font-size: 1.25rem;
    font-weight: 700;
    list-style: none;
    display: flex;
    padding: 0;

    li {
      margin-right: 1.5rem;
      cursor: pointer;

      &::before {
        display: inline-block;
        content: '';
        width: 1em;
      }

      &:hover {
        &:before {
          content: '\2022';
          color: #fff;
        }
      }

      &.is-active {
        &::before {
          content: '\2022';
          color: #fff;
        }
      }
    }
  }

  .chapters-thumbnails {
    overflow-y: scroll;
    flex-wrap: wrap;
    margin: 0 -15px;
    display: flex;
    height: 50%;

    @media screen and (min-width: 992px) {
      overflow-y: auto;
      height: auto;
    }

    .chapter-container {
      padding: 0 15px 30px 15px;
      flex: 1;

      @media screen and (min-width: 992px) {
        flex: 0 0 25%;
      }
    }
  }
}
</style>
